export default __webpack_public_path__ + "static/industryLazyImage-b67b75253e2da47496821df8ab303d61.png";